<template>
  <div class="rewards">
    <div class="rewards-box" v-if="!isCheck">
      <div class="inner" @click.stop>
        <p>Check In For {{ active }} Consecutive day</p>
        <p class="subtitle">Get More Free Coins For Continusly Check</p>
        <div class="inner">
          <div :class="['item', {'already': active >= index}]" v-for="(item, index) in rewards" :key="index">
            <span class="days">DAY {{ index * 1 }}</span>
            <img class="item-icon" src="@/assets/images/icon/diamond.png" alt="" />
            <span class="bonus">+{{ item }}</span>
          </div>
        </div>
        <div class="btn-draw" @click.stop="handleClick"></div>
      </div>
    </div>
    <div class="checked" v-else>
      <p class="title">Congratuation</p>
      <span class="count">+{{ rewardCount }}</span>
      <div class="btn-checked" @click.stop="handleClose"></div>
    </div>
  </div>
</template>
<script>
import { checkIn } from '@/api';
import { debounce } from '@/utils';

export default {
  props: {
    rewards: {
      type: Object,
      default: () => {},
    },
    active: {
      type: [Number, String],
      default: 0,
    },
  },
  created() {
  },
  data() {
    return {
      taskList: [],
      current: 0,
      isCheck: false,
      rewardCount: 0,
    };
  },
  methods: {
    init() {
    },
    handleClose() {
      this.$emit('close');
    },
    handleClick: debounce(async function () {
      const loading = this.$loading({
        backgroundColor: 'transparent',
      });
      const res = await checkIn();
      if (res?.code !== 0) {
        this.$toast(res?.message || 'error');
      } else {
        this.rewardCount = res?.data?.coin_reward || 0;
        this.isCheck = true;
      }
      loading.close();
    }, 500),
  },
};
</script>
<style lang="less" scoped>
.rewards {
  flex: 1;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  .checked {
    width: 360px;
    height: 387px;
    background: url('@/assets/images/bg/rewards-confirm.png') center no-repeat;
    background-size: 100% 100%;
    padding: 200px 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-weight: 700;
    .btn-checked {
      width: 187px;
      height: 44px;
      background: url('@/assets/images/button/confirm.png') center no-repeat;
      background-size: 100% 100%;
      flex-shrink: 0;
    }
    .title {
      font-size: @fontMax;
      color: rgba(21, 114, 90, 1);
    }
    .count {
      margin: 24px 0;
      display: flex;
      align-items: center;
      font-size: @fontLarge;
      &::before {
        content: '';
        width: 32px;
        height: 32px;
        background: url(@/assets/images/icon/diamond.png) no-repeat center;
        background-size: 100%;
        margin-right: 8px;
      }
    }
  }
  .rewards-box {
    background: url('@/assets/images/bg/rewards.png') center no-repeat;
    background-size: 100% 100%;
    width: 360px;
    height: 85%;
    padding: 50% 40px 20px;
    margin-top: 30px;
    position: relative;
    display: flex;
    flex-direction: column;
    p {
      text-align: center;
      font-size: @fontSmall;
      font-weight: 700;
      &.subtitle {
        color: @gray;
      }
    }
    .inner {
      display: flex;
      flex-wrap: wrap;
      margin-top: 24px;
      justify-content: space-around;
      overflow: hidden;
      .item {
        background: rgba(223, 240, 237, 1);
        border-radius: 12px;
        display: flex;
        flex-direction: column;
        margin: 0 2px 8px;
        width: 64px;
        height: 90px;
        font-size: 12px;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        &:last-child {
          flex: 1;
        }
        .item-icon {
          width: 24px;
          height: 24px;
          flex-shrink: 0;
          margin: 4px 0;
        }
        .days {
          color: rgba(78, 202, 168, 1);
          font-weight: 700;
        }
        .bonus {
          font-weight: 500;
        }
        &.already {
          background: linear-gradient(195.34deg, #00EAAB 12.74%, #00C57E 84.97%);
          color: #fff;
          .days {
            color: #fff;
          }
        }
      }
    }
    .btn-draw {
      width: 187px;
      height: 44px;
      background: url('@/assets/images/button/checkin.png') center no-repeat;
      background-size: 100% 100%;
      position: absolute;
      bottom: 28px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
